import { TableBuilder } from '../../../../cdl/TableBuilder/TableBuilder';
import { TableBuilderColumn } from '../../../../cdl/TableBuilder/TableBuilderColumn';
import { Text } from '../../../../cdl/Text/Text';
import { formatDate } from '../../../../common/helpers/formatDate.helper';
import { translate } from '../../../../common/helpers/translate.helper';
import { Box } from '../../../../common/ui/Box';
import { MfaAccessControl } from '../../hooks/useMfaAccessControl';
import { AuthenticatorAppRow } from '../../hooks/useMfaMethodTypes';

import { MfaDropdown } from './MfaDropdown';

interface AuthenticationMethodsTableProps {
    data: AuthenticatorAppRow[];
    accessControl: MfaAccessControl;
    userId: string;
}

export const AuthenticationMethodsTable = ({ data, accessControl, userId }: AuthenticationMethodsTableProps) => {
    if (accessControl.isAnyAdminViewingOthers && data.length <= 0) {
        return <Text variant="small">{translate('mfa.authenticator.emptyAdminState')}</Text>;
    }
    if (data.length <= 0) {
        return <Text variant="small">{translate('mfa.authenticator.emptyState')}</Text>;
    }

    return (
        <>
            <TableBuilder<AuthenticatorAppRow> data={data}>
                <TableBuilderColumn<AuthenticatorAppRow> header={translate('mfa.authenticator.tableHeader.method')}>
                    {(row) => row.method}
                </TableBuilderColumn>
                <TableBuilderColumn<AuthenticatorAppRow> header={translate('mfa.authenticator.tableHeader.dateAdded')}>
                    {(row) => {
                        if (!row.dateAdded) {
                            return null;
                        }
                        return formatDate({ date: row.dateAdded });
                    }}
                </TableBuilderColumn>
                <TableBuilderColumn<AuthenticatorAppRow> header={translate('mfa.authenticator.tableHeader.lastUsed')}>
                    {(row) => {
                        if (!row.lastUsed) {
                            return translate('mfa.authenticator.lastUsedNever');
                        }
                        return formatDate({ date: row.lastUsed });
                    }}
                </TableBuilderColumn>
                {accessControl.canDeleteMfa ? (
                    <TableBuilderColumn<AuthenticatorAppRow> header="" interactive>
                        {(row) => (
                            <Box display="flex" flexWrap="nowrap" justifyContent="flex-end">
                                <MfaDropdown methodId={row.id} accessControl={accessControl} userId={userId} />
                            </Box>
                        )}
                    </TableBuilderColumn>
                ) : null}
            </TableBuilder>
        </>
    );
};
